import { Component, OnInit,Input } from '@angular/core';
import { ConsoleService } from 'src/app/services/console/console.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';

@Component({
  selector: 'app-widget-images-banner-one',
  templateUrl: './widget-images-banner-one.component.html',
  styleUrls: ['./widget-images-banner-one.component.scss'],
})
export class WidgetImagesBannerOneComponent implements OnInit {
  @Input() widgetTitle: any;
  @Input() images: any;
  @Input() background: any;
  @Input() widgetStyle: any;
  @Input() data: any;
  constructor(private consoleService:ConsoleService,private widgetsService:WidgetsService) { }

  ngOnInit() {
    this.consoleService.consoleLog('widget-images-banner-one:18 data', this.data);
  }

  async onClickBanner(bannerData: any) {
    this.widgetsService.bannerLink(bannerData);
  }

}
